import styled from 'styled-components/native';
import theme from '../../global/styles/theme';

interface ButtonAreaProps {
  height?: number;
  marginTop?: number;
  width?: string | number;
  borderRadius?: number;
  backgroundColor?: string;
  border?: string;
  marginBottom?: number;
  borderColor?: string;
  appTheme: 'light' | 'dark';
}

export const ButtonArea = styled.TouchableOpacity<ButtonAreaProps>`
  align-items: center;
  justify-content: center;
  background-color: ${({backgroundColor, appTheme}) =>
    backgroundColor || theme.colors(appTheme).main[700]};
  border-radius: ${({borderRadius}) =>
    borderRadius ? `${borderRadius}px` : '5px'};
  height: ${({height}) => (height ? `${height}px` : '50px')};
  margin-top: ${({marginTop}) => (marginTop ? `${marginTop}px` : '0px')};
  margin-bottom: ${({marginBottom}) =>
    marginBottom ? `${marginBottom}px` : '0px'};
  width: ${({width}) =>
    (width && typeof width === 'number' ? `${width}px` : width) || '100%'};
  border-width: ${({borderColor}) => (borderColor ? '1px' : '0px')};
  border-color: ${({borderColor}) => borderColor || 'transparent'};
`;

export const PlusIcon = styled.Image`
  width: 20px;
  height: 20px;
`;

export const Row = styled.View`
  flex-direction: row;
  align-items: center;
`;
